import * as React from "react";
import { useState } from "react";
import "./TermsAndConditionsForm.scss";
import Form from "./commons/components/form/Form";
import InputState from "./commons/model/form/InputState";
import sfetch from "./commons/utils/super-fetch";
import { LegalResource } from "./legal/LegalResource";
import ConsentCheckboxInput from "./legal/ConsentCheckboxInput";
import { getPayload } from "./commons/utils/form-utils";
import Country from "./commons/model/address/Country";
import { createRoot } from "react-dom/client";

export default function TermsAndConditionsForm({
  legalResources,
  practiceToken,
  country,
  acceptTermsAndConditionsUrl,
}: {
  legalResources: LegalResource[];
  practiceToken?: string;
  country?: Country;
  acceptTermsAndConditionsUrl: string;
}) {
  const [errorMsg, setErrorMsg] = useState<string>();

  const acceptTermsAndConditions = async (form: { [key: string]: InputState }): Promise<any> => {
    const payload = getPayload(form, ["legalDocuments"]);

    return sfetch(acceptTermsAndConditionsUrl, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => document.location.reload())
      .catch((error) => {
        setErrorMsg(i18n["Global.Status.technical_error"]);
        throw error;
      });
  };

  return (
    <Form
      submitLabel={i18n["Page.TermsAndConditions.Accept"]}
      submit={acceptTermsAndConditions}
      generalErrorMsg={errorMsg}
    >
      <div className="image h-flex centered">
        <svg
          width="53"
          height="66"
          viewBox="0 0 53 66"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="customized-svg">
            <path d="M26.9662 0.699947L26.9663 0.699935L26.963 0.698251C26.4584 0.433916 25.8572 0.433916 25.3526 0.698251L25.3525 0.698169L25.3441 0.702809L1.95421 13.5356C1.95398 13.5357 1.95375 13.5358 1.95352 13.536C1.41765 13.8286 1.07764 14.3898 1.07764 15.0183L1.07764 31.753L1.07764 31.7536C1.09499 45.7091 9.3572 58.3459 22.1504 63.9353L22.1504 63.9353L25.3986 65.3542C25.3991 65.3545 25.3996 65.3547 25.4001 65.3549C25.836 65.5482 26.324 65.5484 26.7601 65.3555C26.7611 65.3551 26.762 65.3547 26.763 65.3542L30.4151 63.7842C30.4158 63.7839 30.4165 63.7836 30.4172 63.7833C43.4525 58.3148 51.9224 45.5568 51.9224 31.4279V15.0183V15.0087L51.9221 14.9991C51.8987 14.3917 51.5706 13.8111 51.0057 13.5153C51.005 13.5149 51.0042 13.5145 51.0035 13.5141L26.9662 0.699947ZM29.0702 60.6546L29.0659 60.6564L26.0827 61.9396L23.5095 60.8118L23.5091 60.8117C11.9525 55.7577 4.4732 44.353 4.4732 31.7359V16.016L26.1698 4.12216L48.5098 16.0201V31.4279C48.5098 44.1967 40.8451 55.7189 29.0702 60.6546ZM17.7178 30.659L17.7157 30.6566C17.1106 29.9547 16.0469 29.8587 15.3229 30.462L15.3229 30.462L15.3165 30.4674C14.6146 31.0725 14.5187 32.1362 15.122 32.8602L15.122 32.8603L15.126 32.865L21.4571 40.2741L21.4585 40.2757C22.0582 40.9714 23.1017 41.0776 23.8138 40.4902C23.8144 40.4896 23.8151 40.489 23.8158 40.4885L38.5421 28.5159C38.5426 28.5155 38.5432 28.515 38.5437 28.5146C39.2696 27.9324 39.3939 26.8635 38.7882 26.1323C38.2052 25.408 37.1368 25.2849 36.4064 25.8912C36.4055 25.8919 36.4047 25.8926 36.4039 25.8933L22.9621 36.823L17.7178 30.659Z" />
          </g>
        </svg>
      </div>
      <div className="title-bar">
        <h2 className="title">{i18n["Page.TermsAndConditions.Title"]}</h2>
      </div>
      <p>{i18n["Page.TermsAndConditions.Content"]}</p>
      <ConsentCheckboxInput
        name="legalDocuments"
        legalResources={legalResources}
        onError={() => setErrorMsg(i18n["Legal.Consent.Error"])}
        country={country}
        practiceToken={practiceToken}
      />
    </Form>
  );
}

TermsAndConditionsForm.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<TermsAndConditionsForm {...props} />);
};
